import React, {useContext, useState} from "react";
import moment from "moment-timezone";
import {ConfigProvider, Skeleton, Spin} from "antd";
import {ButtonGroup, RenderOnlyInViewWrapper, SearchByCreatedSwitch} from "../../index.jsx";
import {TableDateSearch} from "../../../admin/components/index.jsx";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {Images} from "../../../images/Images.jsx";
import {TableDateSearchContext} from "../../../admin/Context/TableDateSearchContext.jsx";
import {OrderShortcutFilterValues} from "../../../event/consts.js";
import {useItemListViewActions} from "../useItemListViewActions.jsx";
import {ItemCollapse} from "./ItemCollapse.mobile.jsx";
import {NOOP} from "../../../utils/NOOP.jsx";
import "./item-list-view-date-range.css";
import {PlaceholdersHeights} from "../../../company/EventsGallary/consts.jsx";

const {noOrders} = Images;

export const ItemsListDateRangeMobile = ({
    title,
    extraContent = null,
    data = [],
    isLoading,
    shortcutSearchOptions,
    defaultShortcutSearchOptions,
    log,
    onInputSearch = NOOP,
    panelHeader = {tags: [], description: [], title: "", backgroundColor: () => "white"},
    panelBody = {actions: [], style: {}},
    disableFutureDates = true,
    showSearchByCreatedAt = true,
    totalResultsAmount,
    useLazyLoading = false,
    onLastItemReach = NOOP,
    onItemClick,
    allowDeselectShortcutSearchOptions = true,
    headerExtra = null,
    singleDay = false
}) => {
    const [isShowDateFilter, setIsShowDateFilter] = useState(false);

    const {onShortcutClick, onDatePicker, onSearchByCreatedAtChange, selectedOption} = useItemListViewActions(
        shortcutSearchOptions,
        log,
        defaultShortcutSearchOptions
    );

    const {searchDate, searchByCreated} = useContext(TableDateSearchContext);

    return (
        <div className="item-list-mobile">
            {!!title && <div className="item-list-manage-invoices-title">{title}</div>}
            <div className="item-list-header">
                <div className="item-list-header-top">
                    <ButtonGroup
                        onSelect={onShortcutClick}
                        options={shortcutSearchOptions}
                        selectedOption={selectedOption}
                        defaultSelectedOption={defaultShortcutSearchOptions ?? OrderShortcutFilterValues.PENDING}
                        allowDeselect={allowDeselectShortcutSearchOptions}
                    />
                    {headerExtra}
                    {extraContent}
                </div>

                <div>
                    <div
                        className="item-list-advanced-filter"
                        onClick={() => setIsShowDateFilter(isShowOrderActions => !isShowOrderActions)}>
                        <span>חיפוש מתקדם</span>
                        <span>{isShowDateFilter ? <DownOutlined /> : <UpOutlined />}</span>
                    </div>

                    {!!isShowDateFilter && (
                        <div className="item-list-top-bar-mobile">
                            <TableDateSearch
                                date={searchDate}
                                onDatePicked={onDatePicker}
                                onSearch={onInputSearch}
                                disableFuture={disableFutureDates && searchByCreated}
                                allowClear={false}
                                defaultValue={[moment().startOf("month"), moment().endOf("month")]}
                                className="data-search-mobile"
                                singleDay={singleDay}
                            />

                            {!!showSearchByCreatedAt && (
                                <SearchByCreatedSwitch
                                    searchByCreated={searchByCreated}
                                    onChange={onSearchByCreatedAtChange}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>

            <Spin spinning={isLoading}>
                {data?.length ? (
                    <>
                        {data?.map((order, index) => {
                            return (
                                <>
                                    {useLazyLoading ? (
                                        <RenderOnlyInViewWrapper
                                            key={index}
                                            onEnterView={
                                                index === data.length - 1 && data.length < totalResultsAmount
                                                    ? () => {
                                                          onLastItemReach();
                                                      }
                                                    : NOOP
                                            }
                                            placeholder={
                                                <div className="events-gallery-image-placeholder">
                                                    <Skeleton.Input
                                                        style={{
                                                            height: PlaceholdersHeights[0]
                                                        }}
                                                        active={true}
                                                    />
                                                </div>
                                            }>
                                            <ItemCollapse
                                                onClick={onItemClick}
                                                item={order}
                                                itemIndex={index}
                                                headers={panelHeader}
                                                body={panelBody}
                                            />
                                        </RenderOnlyInViewWrapper>
                                    ) : (
                                        <ItemCollapse
                                            onClick={onItemClick}
                                            item={order}
                                            itemIndex={index}
                                            headers={panelHeader}
                                            body={panelBody}
                                        />
                                    )}
                                </>
                            );
                        })}
                    </>
                ) : (
                    <img className="no-found-orders" src={noOrders} alt="page_not_found_image" />
                )}
            </Spin>
        </div>
    );
};
